<template>
    <div
        v-if="status === 'quiz' || status === 'review'"
        :class="{
            'flex flex-col items-center w-full h-screen p-4 md:flex-row bg-gradient-to-b from-green-transparent to-white':
                status === 'quiz',
            'flex flex-col items-center justify-start w-full h-screen md:p-20 bg-gradient-to-b from-green-transparent to-white':
                status === 'review',
        }"
    >
        <div
            v-if="status === 'quiz'"
            class="items-center justify-center hidden w-full h-full md:flex md:w-1/2"
        >
            <img
                :src="questionImage"
                alt="Quiz"
                class="hidden object-contain remove_bg_color md:block"
            />
        </div>

        <Card
            :class="{
                'w-full md:w-[45%] mt-36 md:mt-0 ': status === 'quiz',
                'w-full h-dvh ': status === 'review',
            }"
            :quiz="quiz"
            :status="status"
            @update:status="status = $event"
            @update:score="score = $event"
        />

        <img
            v-if="status === 'review'"
            src="/storage/assets/images/quiz/failed.svg"
            alt="Quiz"
            class="bottom-0 hidden object-contain remove_bg_color sm:fixed sm:block md:right-4"
        />
    </div>
    <div
        v-else-if="status === 'result'"
        class="flex flex-col items-center justify-start w-full h-screen px-4 pb-4 bg-gradient-to-b from-green-transparent to-white"
    >
        <img :src="imageSrc" alt="Result" class="object-contain" />
        <Card custom class="w-[60%] mb-36" :email="email">
            <div
                class="flex flex-col items-center justify-center w-full h-full gap-4 text-center"
            >
                <template v-if="isPassed">
                    <h1 class="m-0 mt-2 text-3xl font-bold text-black">
                        {{ $translate('public.quiz.congrats') }}
                    </h1>
                    <p class="flex flex-col mt-4 text-lg text-center">
                        <span> {{ $translate('public.quiz.score') }}</span>
                        <span class="text-xl font-bold text-green">
                            {{ score }}/{{ maxScore }}
                        </span>
                    </p>

                    <simple-button @click="router.go()">
                        {{ $translate('public.quiz.buttons.login') }}
                    </simple-button>
                </template>
                <template v-else>
                    <h1 class="m-0 mt-2 text-3xl font-bold text-black">
                        {{ $translate('public.quiz.bad') }}
                    </h1>
                    <p class="flex flex-col mt-4 text-lg text-center">
                        <span> {{ $translate('public.quiz.score') }}</span>
                        <span class="text-xl font-bold text-red">
                            {{ score }}/{{ maxScore }}
                        </span>
                    </p>
                    <p>
                        {{ $translate('public.quiz.failed') }}
                        <span class="font-bold"
                            >{{ quiz.min_score }}/{{ maxScore }}</span
                        >.
                    </p>
                    <div class="flex justify-center gap-2">
                        <primary-button
                            @click="status = 'review'"
                            class="mt-4 border-2 border-green"
                            color="white"
                            >{{
                                $translate('public.quiz.buttons.results')
                            }}</primary-button
                        >
                        <primary-button
                            @click="status = 'quiz'"
                            class="mt-4"
                            color="green"
                            >{{
                                $translate('public.quiz.buttons.retry')
                            }}</primary-button
                        >
                    </div>
                </template>
            </div>
        </Card>
    </div>
</template>

<script setup>
import { useQuizStore } from '@/js/stores/quizStore';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import Card from './Card.vue';

const status = ref('quiz');
const score = ref(0);
const router = useRouter();
const quizStore = useQuizStore();

const isPassed = computed(() => score.value >= props.quiz.min_score);
const imageSrc = computed(() => {
    return isPassed.value
        ? '/storage/assets/images/quiz/won.svg'
        : '/storage/assets/images/quiz/failed.svg';
});

const props = defineProps({
    quiz: {
        type: Object,
        required: true,
    },
    email: {
        type: String,
        required: true,
    },
});

const questionImage = computed(() => {
    return props.quiz.questions[quizStore.step].file
        ? import.meta.env.VITE_API_URL +
              '/api/image/private' +
              props.quiz.questions[quizStore.step].file
        : '/storage/assets/images/quiz/question.png';
});

const maxScore = computed(() => {
    return props.quiz.questions.reduce((total, question) => {
        return total + (question.points.positive || 0);
    }, 0);
});
</script>
